import moment from 'moment'

export const getFormattedDateForServer = (date) =>
	date && moment(new Date(date)).format('YYYY/MM/DD')

export const getFirstDateOfCurrentMonth = () =>
	moment().startOf('month').utc().toISOString()

export const getLastDateOfCurrentMonth = () =>
	moment().endOf('month').utc().toISOString()

export const getUTCStartDate = (date) =>
	date && moment(date).startOf('day').utc().toISOString()

export const getUTCEndDate = (date) =>
	date && moment(date).endOf('day').utc().toISOString()

export const getFEFormattedDate = (date) => date && moment(date).format('ll')

export const getLocalDateFromUTC = (date) => {
	// TODO: Need to send the null from the backend
	if (date && date.startsWith('0001')) return null
	return date && moment.utc(date).local().format('MM/DD/YY')
}

export const getDateAndTimeFormatter = (date) =>
	date && moment(date).format('L hh:mma')

export const getFormattedDateForVarianceData = (date) => {
	if (date && date.startsWith('0001')) return null
	return date && moment.utc(date).local().format('MMM DD, YYYY')
}

export const getFormattedDate = (date) => {
	return date && moment(new Date(date)).format('MM/DD/YY')
}
